function initProductCards(parent = document) {
  var allCards = parent.querySelectorAll(".card-product");
  allCards.forEach(function (product) {
    setupSwatchRow(product);
    setupCardGallery(product);
    product.addEventListener("click", function (e) {
      var colorOption = e.target.closest(".card-product__color-option");
      if (colorOption) {
        e.preventDefault();
        handleColorSwatch(colorOption, product);
      }
    });
  });
}

function setupCardGallery(card) {
  var track = card.querySelector("[data-card-gallery]");
  if (!track) return;
  var max = parseInt(track.getAttribute("data-max") || "1", 10);
  if (max <= 1) return;
  var prevBtn = card.querySelector("[data-card-gallery-prev]");
  var nextBtn = card.querySelector("[data-card-gallery-next]");
  var index = 0;

  function applyTransform() {
    track.style.transform = "translateX(-" + 100 * index + "%)";
  }

  function goNext() {
    index = (index + 1) % max;
    applyTransform();
  }

  function goPrev() {
    index = (index - 1 + max) % max;
    applyTransform();
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      goPrev();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      goNext();
    });
  }

  applyTransform();
}

function setupSwatchRow(product) {
  var wrap = product.querySelector("[data-swatch-scroll]");
  if (!wrap) return;
  var viewport = wrap.querySelector(".card-product__colors-viewport");
  var row = wrap.querySelector(".card-product__colors--row");
  var prevBtn = wrap.querySelector("[data-swatch-prev]");
  var nextBtn = wrap.querySelector("[data-swatch-next]");
  if (!viewport || !row) return;

  function getStep() {
    var first = row.querySelector(".card-product__color-option");
    if (!first) return 0;
    var cs = getComputedStyle(row);
    var gap =
      parseFloat(cs.gap) ||
      parseFloat(cs.columnGap) ||
      parseFloat(cs.rowGap) ||
      0;
    return first.getBoundingClientRect().width + gap;
  }

  function updateArrows() {
    var maxScroll = row.scrollWidth - viewport.clientWidth;
    // If there is *any* overflow, we want arrows to show.
    // Mobile layouts can reduce overflow to just a few pixels, so use a small threshold.
    var threshold = 1;
    if (maxScroll <= threshold) {
      if (prevBtn) {
        prevBtn.style.opacity = "0";
        prevBtn.style.pointerEvents = "none";
      }
      if (nextBtn) {
        nextBtn.style.opacity = "0";
        nextBtn.style.pointerEvents = "none";
      }
    } else {
      var left = viewport.scrollLeft;
      if (prevBtn) {
        var showPrev = left > threshold;
        prevBtn.style.opacity = showPrev ? "1" : "0";
        prevBtn.style.pointerEvents = showPrev ? "auto" : "none";
      }
      if (nextBtn) {
        var showNext = left < maxScroll - threshold;
        nextBtn.style.opacity = showNext ? "1" : "0";
        nextBtn.style.pointerEvents = showNext ? "auto" : "none";
      }
    }
  }

  function scrollByStep(dir) {
    var step = getStep();
    if (step <= 0) return;
    viewport.scrollBy({ left: dir * step, behavior: "smooth" });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      scrollByStep(-1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      scrollByStep(1);
    });
  }

  viewport.addEventListener("scroll", updateArrows, { passive: true });

  if (typeof ResizeObserver !== "undefined") {
    var ro = new ResizeObserver(function () {
      updateArrows();
    });
    ro.observe(viewport);
    ro.observe(row);
  } else {
    window.addEventListener("resize", updateArrows, false);
  }

  wrap.classList.add("is-ready");
  row.removeAttribute("aria-hidden");
  updateArrows();
}

function handleColorSwatch(colorOption, productCard) {
  if (colorOption.getAttribute("aria-current") === "true") return;
  var featuredImage = productCard.querySelector(
    ".card-product__image-container .card-product__image"
  );
  var colors = colorOption.closest(".card-product__colors");
  if (colors) {
    colors
      .querySelectorAll(".card-product__color-option")
      .forEach(function (btn) {
        btn.setAttribute("aria-current", "false");
      });
  }
  colorOption.setAttribute("aria-current", "true");
  var newImageSrc = colorOption.dataset.imageSrc;
  var newAltText = colorOption.dataset.imageAlt;
  if (featuredImage && newImageSrc) {
    featuredImage.src = newImageSrc;
    featuredImage.alt = newAltText;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initProductCards();
  window.initProductCards = initProductCards;
});

document.addEventListener("shopify:section:load", function (e) {
  initProductCards(e.target);
});
